export default __webpack_public_path__ + "static/media/Competitive.6adc2abd.png";